<div class="content">
    <h2>Ihre Ansprechpartner</h2>
    <redispatch-contact-data-list></redispatch-contact-data-list>
    <div class="disclaimer-container" fxLayout="row" fxLayoutGap="1rem">
        <mat-icon class="disclaimer-icon" svgIcon="innogy_picto_speech-bubble_exclamationmark"></mat-icon>
        <div fxLayout="column" fxLayoutGap=".8rem">
            <div class="disclaimer-text">
                Die individuellen Anwahlnummern der Direktleitungen sowie die Faxnummern und E-Mail-Adressen sind streng vertraulich zu behandeln und dürfen nicht weiter gegeben werden.
            </div>
            <div class="disclaimer-text">
                Für den Fall, dass das TNB-Portal TDL temporär nicht erreichbar ist, müssen die angegebenen Kontaktdaten krisensicher abgelegt werden.
            </div>
        </div>
    </div>

    <div>

    </div>
</div>

